import { Dispatch, SetStateAction } from "react";

import { ITableModel } from "components/Table/interface";
import { HealthOperatorProps } from "models/HealthOperator";
import { IBatchRequestResponse } from "models/Batch";

export interface TableDataIntegrationProps {
  trackingKey: string;
  model?: Array<ITableModel>;
  dataIntegration: IBatchRequestResponse<HealthOperatorProps>;
  currentPage: number;
  setCurrentPage: Dispatch<SetStateAction<number>>;
  DropdownTemplate?: any;
  pageSize?: number;
}

export enum StatusFlowEnum {
  HEALTH_OPERATOR_WITHOUT_BUY_ORDER = "Ordem de Compra Inválida",
  HEALTH_OPERATOR_INCORRECT_BUY_ORDER = "Ordem de Compra Inválida",
  HEALTH_OPERATOR_WITHOUT_PRODUCT = "Sem Produto",
  ERROR_SENT_INVOICE = "Erro Envio Nota Fiscal",
  ERROR_SENT_RECEIPT = "Erro Envio Comprovante",
  PENDING_SEARCH = "Pendente Pesquisa",
  MANUAL_ACTION_REQUIRED = "Necessário Ação Manual",
  PENDING_SEND_INVOICE = "Pendente Envio Nota Fiscal",
  SENT_INVOICE = "Nota Fiscal Enviada",
  PENDING_RECEIPT = "Pendente Envio Comprovante",
  CONFIRMED_INVOICE = "Nota Fiscal Confirmada",
  SENT_RECEIPT = "Comprovante Enviado",
  FINISHED = "Finalizado",
}